import { ApplicationConfig, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';

import { provideJira } from '@tmt/jira';

import { routes } from 'src/app/app.routes';
import { ThemeService } from 'src/app/services/theme.service';
import { ColorblindService } from 'src/app/services/colorblind.service';
import { authInterceptor } from 'src/app/interceptors/auth.interceptor';
import { ApolloClientService } from 'src/app/services/apollo-client.service';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes),
		provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
		ThemeService,
		ColorblindService,
		provideJira(() => inject(ApolloClientService).apolloClient$),
	],
};
